//Central color codes

//background gradient
export const COLOR_BACKGROUND_START = '#1B1030';
export const COLOR_BACKGROUND_END = '#2E1A47';

//brand
export const COLOR_PRIMARY = '#E93D82';
export const COLOR_SECONDARY = '#FFC857';

//text
export const COLOR_TEXT_PRIMARY = '#F2EEF5';
export const COLOR_TEXT_MUTED = '#C9BFE0';

//semantic feedback
export const COLOR_SUCCESS = '#3DDC97';
export const COLOR_ERROR = '#FF5C5C';
export const COLOR_WARNING = '#FFC857';

//panel surface
export const COLOR_PANEL_BACKGROUND = 'rgba(255,255,255,0.06)';
export const COLOR_PANEL_BORDER = 'rgba(255,255,255,0.12)';
